angular.module('b2bLoginApp.directives').directive('deletePhoto', ["$uibModal", "$http", "TranslationService", "Loading", function ($uibModal, $http, TranslationService, Loading) {
    return {
        restrict: 'A',
        scope: {
            'photo': '=',
            'onDeleted': "&onDeleted"
        },
        template: '<a class="dropdown-item" ng-click="openDeletePhotoDialog()">[[ deletePhotoLabel ]]</a>',
        link: function (scope) {
            var deleteLabel = 'company-profile-public.photos.delete_photo';
            scope.deletePhotoLabel = TranslationService.trans(deleteLabel);
            scope.loading = Loading;

            scope.openDeletePhotoDialog = function () {
                var modal = $uibModal.open({
                    templateUrl: '/account/company-profile-public/delete-photo.html',
                    backdrop: 'static',
                    keyboard: false,
                    scope: scope,
                    size: 'lg',
                    openedClass: 'company-profile-modal company-photos-modal modal-open',
                    controller: ["$scope", function ($scope) {
                        $scope.removePhoto = function() {
                            $http.delete('company-profile-public/photo/' + scope.photo.name + '.json').then(function() {
                                scope.onDeleted(scope.photo);
                                modal.close();
                            });
                        };
                    }]
                });
            };
        }
    };
}]);
